"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../data/store/store");
var owa_options_core_1 = require("owa-options-core");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default(); },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications);
    },
})(legacy_1.action('saveSkypeOptions')(function saveSkypeOptions(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.skypeMessageNotification = owa_options_core_1.getFallbackValueIfNull(optionState.imNotification, userOptions.skypeMessageNotification);
                    userOptions.skypeCallingNotification = owa_options_core_1.getFallbackValueIfNull(optionState.callNotification, userOptions.skypeCallingNotification);
                    return [4 /*yield*/, owa_outlook_service_options_1.lazyCreateOrUpdateOptionsForFeature.importAndExecute(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSkypeOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/orchestration/saveSkypeOptions.js
// module id = 3374
// module chunks = 2 39